import './nameDialog.css'
import WooLogin from '../WooNotes/WooLogin'
import { IPlayer } from '../Services/ServiceSecurity'

type Props = {
  isUnauthorized: boolean
  onLogin: (token: string, player: IPlayer) => void
}

export const IsUnauthorizedDialog = ({ isUnauthorized, onLogin }: Props) => {
  if (!isUnauthorized) return null

  return (
    <div className="dialog-root authOverlay">
      {/* <div className="dialog-backdrop" onClick={onCancel} /> */}

      <div className="dialog">
        <h3>You are no longer authorized, please relogin</h3>

        <WooLogin onLogin={onLogin} />
      </div>
    </div>
  )
}
